<!-- @format -->

@if (prerequisites) {
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-group-mimic">
        <sis-description-list>
          <dl>
            <ng-template #listItem>
              <dt class="sis-label">{{ "STUDIES.COURSE_UNIT_INFO_MODAL.PREREQUISITES_DESCRIPTION" | translate }}</dt>
              <dd><sis-localized-markup-string-view [content]="prerequisites"></sis-localized-markup-string-view></dd>
            </ng-template>
          </dl>
        </sis-description-list>
      </div>
    </div>
  </div>
}
@if (compulsoryFormalPrerequisites?.length > 0 || recommendedFormalPrerequisites?.length > 0) {
  <div class="row">
    @if (compulsoryFormalPrerequisites?.length > 0) {
      <div class="col-12 col-md-5">
        <sis-basic-grouping-panel [heading]="'STUDIES.COURSE_UNIT_INFO_MODAL.OVERVIEW_COMPULSORY_FORMAL_PREREQUISITES'" [level]="5">
          <sis-prerequisites [prerequisites]="compulsoryFormalPrerequisites" [level]="6"></sis-prerequisites>
        </sis-basic-grouping-panel>
      </div>
    }
    @if (recommendedFormalPrerequisites?.length > 0) {
      <div class="col-12 col-md-5 offset-md-1">
        <sis-basic-grouping-panel [heading]="'STUDIES.COURSE_UNIT_INFO_MODAL.OVERVIEW_RECOMMENDED_FORMAL_PREREQUISITES'" [level]="5">
          <sis-prerequisites [prerequisites]="recommendedFormalPrerequisites" [level]="6"></sis-prerequisites>
        </sis-basic-grouping-panel>
      </div>
    }
  </div>
}
@if (!prerequisites && compulsoryFormalPrerequisites?.length === 0 && recommendedFormalPrerequisites?.length === 0) {
  <div>
    <span>{{ "SIS_COMPONENTS.COURSE_UNIT_REALISATION_INFO.NO_INFORMATION_GIVEN" | translate }}</span>
  </div>
}
